/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function ScrollProgressBrowser(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'ScrollProgressBrowser',
      'aria-hidden': true,
      focusable: false,
      width:  82 * scale,
      height: 44 * scale,
      viewBox: '0 0 82 44',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('defs', null,createElement('path', {"d":"M0 .997A1 1 0 0 1 .992 0h50.016c.548 0 .992.443.992.997v40.006a1 1 0 0 1-.992.997H.992A.993.993 0 0 1 0 41.003zM6.5 3.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M2 5v35h48V5z","id":"wf-svg-ScrollProgressBrowser-__a"}),createElement('mask', {"id":"wf-svg-ScrollProgressBrowser-__b","x":"-1","y":"-1","width":"54","height":"44"},createElement('path', {"fill":"#fff","d":"M-1-1h54v44H-1z"}),createElement('use', {"xlinkHref":"#wf-svg-ScrollProgressBrowser-__a"}))),createElement('g', {"fill":"none","fillRule":"evenodd"},createElement('g', {"transform":"translate(1 1)"},createElement('use', {"fill":"#D6D6D6","xlinkHref":"#wf-svg-ScrollProgressBrowser-__a"}),createElement('use', {"stroke":"#595959","mask":"url(#wf-svg-ScrollProgressBrowser-__b)","strokeWidth":"2","xlinkHref":"#wf-svg-ScrollProgressBrowser-__a"})),createElement('path', {"d":"M57 40.5h25m-25-34h25","stroke":"#A9A9A9","strokeDasharray":"1,1"}),createElement('path', {"fill":"#A9A9A9","d":"M70 41V6h-1v35z"})))
}
